import { AxiosError } from "axios";
import { handleApiError } from "./instanceApi";
import { moodleInstanceApi } from "./moodleInstanceApi"

export const getMessage = async(userid?:any) => {
    try{
        const response = await moodleInstanceApi.get(
            "/webservice/rest/server.php",
            {
                params: {
                    wsfunction: "core_message_get_messages",
                    useridto: userid,
                    read: 0,
                    type:"notifications",
                    newestfirst: 1,
                }
            }
        );
        return response?.data;
    }catch (error) {
        return handleApiError(error as AxiosError);
    }
}